export default __webpack_public_path__ + "static/media/shopdefault.ced38a07.png";